import React, { useEffect, useCallback } from 'react'
import { connect } from 'react-redux'
import { debounce } from 'lodash'
import SidePanel from './SidePanel'
import MainCalendarView from './MainCalendarView'

export default function Calendar(props){
  return(
    <div className="d-flex align-items-start p-3" style={{height: 'calc(100vh - 56px)', backgroundColor: 'transparent', overflowY: 'scroll'}}>
      <div className="h-100 d-lg-flex align-items-start w-100 main-container" style={{backgroundColor: 'white', overflowY: 'scroll'}}>
        <SidePanel/>
        <MainCalendarView/>
      </div>
    </div>
  )
}


